import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {observable} from "mobx";
import { compose } from "recompose";
import { withRouter, Link } from "react-router-dom";
import { withAuthorization, createUser } from "./utils/auth";
import * as CalculateRate from "./utils/calculateRateAndPrice";

import {
  Form,
  Spin,
  Button,
  Input,
  Tag,
  Icon,
  Divider,
  Avatar,
  Rate,
  List
} from "antd";
import UserForm from "./UserForm";
import moment from 'moment';

import { Document, Collection } from "firestorter";
const FormItem = Form.Item;


@observer
class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.location.data ? this.props.location.data.user : null,
      loading: null,
      isReadOnly: true,
      userIds: {}
    };

    this.updateUser = this.updateUser.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.getUser = this.getUser.bind(this);
    this.getReqEmail = this.getReqEmail.bind(this);
    this.switchEdit = this.switchEdit.bind(this);
    console.log("userdetails props", this.props);
  }
  componentWillReceiveProps(){
    console.log('DERIVED');
  }
  userDocument = new Document("users/" + this.props.match.params.uid, {
    realtimeUpdating: "on"
  });
  async getUser(userId){
    if(this.state.userIds[userId] === undefined){
      var prev = {...this.state.userIds};
      prev[userId] = "fetching";
      this.setState({userIds: prev});
      console.log('Fetching email for user: ', userId);
      var userEmailDocument = new Document("users/" + userId, {
        mode: "off"
      });
      const user = await userEmailDocument.fetch();
      prev = {...this.state.userIds};
      prev[userId] = user.data;
      this.setState({userIds: prev});
      console.log('State', this.state.userIds);
    }
    // var userEmailDocument = new Document("users/" + userId, {mode: "off"});
    // const user = await userEmailDocument.fetch();
    // return user.data.email;
  }

  componentDidMount() {
    this.setState({ loading: true });
    const user = this.userDocument.fetch();

    user.then(async ({data}) => {
      this.setState({ user: data });
      console.log("{user}", data);
      if(data.role == "nurse"){
        console.log('IS NURSE');
        this.props.userStore.requests.query = this.props.userStore.requests.ref.where('nurse.id', '==', this.props.match.params.uid).orderBy('startTime', 'asc');
        // this.props.userStore.requests.docs.map((doc,i) => {
        //   this.getUser(doc.data.author);
        // });
        this.props.userStore.transactions.query = this.props.userStore.transactions.ref.where('creditedWalletId', '==', data.walletId).where('type', '==', 'transfer')
        // this.props.userStore.transactions.fetch().then((collection) => {
        //   var total = 0;
        //   console.log('transactions length', collection.docs.length)
        //  collection.docs.forEach((doc) => {
        //    // if(doc.data.processed && doc.data.processed !== "cancelled" && !doc.data.refund){
        //    if(doc.data.isCancelled != 'invalid' && doc.data.payment != 'cancelled' && doc.data.paymentFailed != true && doc.data.payment != 'refunded' && !doc.data.refund){
        //      total = total + doc.data.debitedFunds;
        //    }
        //    this.setState({money_spent: (total / 10).toFixed(2) })
        //  });
        //  if(!this.state.money_spent){
        //    this.setState({money_spent: "0" })
        //  }
        // });

      } else if (data.role == "patient" || data.role == "admin") {
        console.log('IS PATIENT', this.props.match.params.uid);
        this.props.userStore.requests.query = this.props.userStore.requests.ref.where('author', '==', this.props.match.params.uid).orderBy('startTime', 'asc');
        console.log("FETCHING TRANSACTIONS!!");
        if(data.mangoId) {
        //   this.props.userStore.transactions.query = this.props.userStore.transactions.ref.where('authorId', '==', data.mangoId).where('type', '==', 'payin')
        //   this.props.userStore.transactions.fetch().then((collection) => {
        //     var total = 0;
        //     console.log('transactions length', collection.docs.length)
        //    collection.docs.forEach((doc) => {
        //      if(doc.data.isCancelled != 'invalid' && doc.data.payment != 'cancelled' && doc.data.paymentFailed != true && doc.data.payment != 'refunded' && !doc.data.refund){
        //      // if(doc.data.processed && doc.data.processed !== "cancelled" && !doc.data.refund){
        //        total = total + doc.data.debitedFunds;
        //      }
        //
        //    });
        //    this.setState({money_spent: (total / 100).toFixed(2) })
        //   });
        //   if(!this.state.money_spent){
        //     this.setState({money_spent: "0" })
        //   }
        } else {
          // this.setState({money_spent: "Indisponible" })
        }


        // this.props.userStore.requests.docs.map((doc,i) => {
        //   this.getUser(doc.data.nurse.id);
        // });
      }
      await this.props.userStore.requests.fetch();
      var reqCount = 0;
      var hours = 0;
      var totalMoney = 0;
      // var total = 0;
      var requests = this.props.userStore.requests.docs.map((doc,i) => { //traverse requests
        var userId = undefined;
        if (data.role == "patient") {
          userId = doc.data.nurse.id;
          // if(doc.data.isCancelled != 'invalid' && doc.data.payment && doc.data.payment != 'cancelled' && doc.data.paymentFailed != true && doc.data.payment != 'refunded' && !doc.data.refund){
          // // if(doc.data.processed && doc.data.processed !== "cancelled" && !doc.data.refund){
          //   total = total + doc.data.duration * 1990;
          // }
        }
        if (data.role == "nurse") {
          userId = doc.data.author;
        }

        if(moment(doc.data.endTime).isBefore(moment()) && doc.data.isCancelled != 'invalid' && doc.data.payment && doc.data.payment != 'cancelled' && doc.data.paymentFailed != true && doc.data.payment != 'refunded' && !doc.data.refund){
          if (!isNaN(doc.data.duration)) {
            reqCount++;
            hours = hours + Number(doc.data.duration);
            totalMoney += CalculateRate.getRate(doc.data.startTime, doc.data.endTime)[data.role == "nurse" ? "n" : "r"];
            console.log("total money: " + totalMoney);
          }
        }
        this.getUser(userId);
          return ({
                key: i,
                startTime: doc.data.startTime,
                endTime: doc.data.endTime,
                tasks: doc.data.tasks,
                zipCode: doc.data.zipCode,
                user: doc.data.author,
                nurseId: doc.data.nurse.id,
                doc: doc
              })
      });
      console.log('Requests',requests);
      console.log('Req Count: ', reqCount, hours);
      this.setState({
        money_spent: totalMoney.toFixed(2), 
        requests: requests,
        reqCount: String(reqCount),
        reqTotalHours: String(hours)
      });
    })
    this.setState({ loading: false });
    // if (this.state.user == null) {
    //   this.setState({ loading: true });
    //   const user = await this.userDocument.fetch();
    //   var requests = null;
    //   this.setState({ user: user });
    //   console.log("{user}", user);
    //   this.setState({ loading: false });
    // } else {
    // }
    // if(this.state.user.data.role == "nurse"){
    //   console.log('IS NURSE');
    //   this.props.userStore.requests.query = this.props.userStore.requests.ref.where('nurse.id', '==', this.props.match.params.uid);
    //   this.props.userStore.requests.docs.map((doc,i) => {
    //     this.getUser(doc.data.author);
    //   });
    // } else if (this.state.user.data.role == "patient" || this.state.user.data.role == "admin") {
    //   console.log('IS PATIENT', this.props.match.params.uid);
    //   this.props.userStore.requests.query = this.props.userStore.requests.ref.where('author', '==', this.props.match.params.uid);
    //   this.props.userStore.requests.docs.map((doc,i) => {
    //     this.getUser(doc.data.nurse.id);
    //   });
    // }
  }

  async doDelete() {
    this.setState({ loading: true });
    await this.userDocument.delete();
    this.setState({ loading: false });
    this.props.history.push("/users");
  }
  async updateUser(data) {
    try {
      console.log('data ', data);
      await this.userDocument.update(data, { merge: true });
      this.setState({isReadOnly: true, user: data});
    } catch (e) {
      throw new Error(e);
    }
  }
  // async getUser(userId){
  //   if(!this.state.usersEmailandPic[userId]){
  //     var userDocument = new Document("users/" + userId, {
  //       mode: "off"
  //     });
  //     const user = await userDocument.fetch();
  //     var prev = {...this.state.usersEmailandPic};
  //     prev[userId] = user.data;
  //     this.setState({usersEmailandPic: prev});
  //   }
  // }
  switchEdit() {
    if(!this.state.isReadOnly){
      console.log('user', this.user)
      this.setState(this.props.user ? {user: {...this.props.user}} : {user: this.state.user});
      // this.setState(this.props.user ? {...this.props.user} : {...Object.keys(this.state).forEach(v => this.state[v] = null)} )}
      console.log('STATe', this.state.user);
    }
    this.setState({ isReadOnly: !this.state.isReadOnly })
  }
  getReqEmail(item){
    if(this.state.user && this.state.user.role === 'patient' && this.state.userIds[item.nurseId]) {
      return (<Link to={'/users/'+item.nurseId}>{this.state.userIds[item.nurseId].email}</Link>);
    } else if(this.state.user && this.state.user.role === 'nurse' && this.state.userIds[item.user]) {
      return (<Link to={'/users/'+item.user}>{this.state.userIds[item.user].email}</Link>);
    } else {
      return 'Chargement...'
    }
  }
  getPic(item){
    if(this.state.user && this.state.user.role === 'patient' && this.state.userIds[item.nurseId]) {
      return (<Avatar src={this.state.userIds[item.nurseId].pic} />);
    } else {
      return null
    }
  }
  render() {
    // const {user} = this.state;
    console.log("re-render");
    const { firstname, lastname, pic, rate, role } = this.state.user
      ? this.state.user
      : ["?", "?", "", "0/0", "?"];

    const userRating = rate ? Number((rate.split('/')[0]/rate.split('/')[1]).toFixed(2)) : 0;
    const ratingsCount = rate ? rate.split('/')[1] : 0;

    return (
      <div>
        <Spin
          spinning={this.state.loading || this.props.userStore.users.fetching}
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "baseline",
              position: "absolute",
              right: 0,
              zIndex: 1000
            }}
          >
            <p style={{ margin: 5 }}>Opérations:</p>
            <Button
              style={{ margin: 5 }}
              type="primary"
              onClick={() => this.switchEdit()}
              loading={
                this.state.loading || this.props.userStore.users.fetching
              }
            >
              {this.state.isReadOnly ? 'Modifier' : 'Annuler'}
            </Button>

            <Button
              style={{ margin: 5 }}
              type="danger"
              onClick={this.doDelete}
              disabled={role === "admin"}
              loading={
                this.state.loading || this.props.userStore.users.fetching
              }
            >
              Supprimer
            </Button>
          </div>
          <br />
          <Divider orientation="left">
            <div style={{ display: "flex", alignItems: "center" }}>
              {pic ? (
                <Avatar
                  style={{ alignSelf: "center" }}
                  shape="square"
                  size="large"
                  icon="user"
                  src={pic}
                />
              ) : null}{" "}
              <span style={{display: 'flex', flexDirection: 'Column'}}>
                <h2 style={{ alignSelf: "center", marginBottom: 0, marginLeft: 15 }}>
                  {firstname} {lastname}
                </h2>
                {rate ? <Rate disabled allowHalf defaultValue={userRating.toFixed(0)} /> : null}
                {rate && <p>({userRating}/5 - {ratingsCount} notes)</p>}
              </span>
            </div>
          </Divider>
          <br />
          <Spin
            spinning={this.state.money_spent === null || this.state.reqCount === null || this.state.reqTotalHours === null }
            indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
          >
            <div className="stats_bar" style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between'}}>
              <span style={{ justifyContent: 'center', flexGrow: 1, display: 'flex'}}>
                <div>
                  <h1> {this.state.money_spent || "_.__"}</h1>
                  <h2>Euros</h2>
                </div>
              </span>
              <span style={{ justifyContent: 'center', flexGrow: 1, display: 'flex'}}>
                <div>
                  <h1>{this.state.reqCount || "_"}</h1>
                  <h2>Prestations</h2>
                </div>
              </span>
              <span style={{ justifyContent: 'center', flexGrow: 1, display: 'flex'}}>
                <div>
                  <h1>{this.state.reqTotalHours || "_"}</h1>
                  <h2>Heures</h2>
                </div>
              </span>
            </div>
            <h3>Inscrit le:  {this.state.user && this.state.user.createTime ? moment(this.state.user.createTime).format('Do MMMM YYYY') : "Indisponible"}</h3>
            <h3>Identifiant: {this.props.match.params.uid}</h3>
          </Spin>

          <br />
            {this.state.user ? (
              <UserForm
                disabled={this.state.isReadOnly}
                user={this.state.user}
                switchFunc={this.switchEdit}
                submit={this.updateUser}
              />
            ) : null}
          <br />
          <h3>Liste des prestations</h3>
          <List
            dataSource={this.state.requests}
                  renderItem={item => (
                    <List.Item actions={[<Link to={'/requests/'+item.doc.id}>Voir</Link>]}>
                      <List.Item.Meta
                        avatar={this.getPic(item)}
                        title={<a>{moment(item.startTime).format('HH[h]mm DD-MM-YYYY') + '->' + moment(item.endTime).format('HH[h]mm DD-MM-YYYY')}</a>}
                        description={ this.getReqEmail(item)} />
                    </List.Item>
                  )}
            />




        </Spin>
      </div>
    );
  }
}


const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject("userStore"),
  withRouter,
  observer
)(UserDetails);



// WEBPACK FOOTER //
// ./src/UserDetails.js